import React, {Component} from 'react';
import { Link } from 'react-router';
import { connect } from 'react-redux';

import ShopifyStore from '../../containers/ShopifyStore';
import ShopNav from '../../components/ShopNav';
import EmailSignup from '../../components/Sections/EmailSignup';
import LoadingIcon from '../../components/LoadingIcon';

function mapStateToProps(state) {
   return {
    shopIsLoaded: state.shop.isLoaded,
  };
}

function mapDispatchToProps(dispatch) {
  return {
  }
}

class Store extends Component {

  render() {
    const { shopIsLoaded } = this.props;

    console.log('check shopIsLoaded', shopIsLoaded)
    return (
      <div className="Contact">
        <h1 className="center">Moose Almighty Store</h1>
        <ShopifyStore />
        <EmailSignup />
      </div>
    )
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Store);

        // { !shopIsLoaded ? 
        //   <LoadingIcon message="Loading store..." />
        //   : null
        // }


// WEBPACK FOOTER //
// ./src/views/Store/Store.js